/**
 * FormBuilderNode Hook
 *
 * Handles dynamic interactions for the form builder interface.
 * Enables instant focusing of elements as they come into the DOM through MutationObserver.
 *
 */
export default {
  mounted() {
    this.pendingFocus = null;

    const formContainer = this.el.querySelector('.form-nodes-container');
    this.observer = new MutationObserver(() => {
      if (this.pendingFocus) {
        this.attemptFocus(this.pendingFocus);
      }
    });

    this.observer.observe(formContainer, {
      childList: true,
      subtree: true,
      attributes: false
    });

    this.handleEvent("focus_node", ({nodeId}) => {
      this.pendingFocus = {type: 'node', nodeId};
      this.attemptFocus({type: 'node', nodeId});
    });

    this.handleEvent("focus_option", ({nodeId, optionId}) => {
      this.pendingFocus = {type: 'option', nodeId, optionId};
      this.attemptFocus({type: 'option', nodeId, optionId});
    });
  },

  destroyed() {
    if (this.observer) {
      this.observer.disconnect();
    }
  },

  attemptFocus(focusTarget) {
    if (!focusTarget) return false;

    let elementId;
    if (focusTarget.type === 'node') {
      elementId = `title-${focusTarget.nodeId}`;
    } else if (focusTarget.type === 'option') {
      elementId = `option-label-${focusTarget.nodeId}-${focusTarget.optionId}`;
    } else {
      return false;
    }

    return this.focus_click_to_edit(elementId);
  },

  focus_click_to_edit(elementId) {
    const displayEl = document.getElementById(`${elementId}-display`);
    const editFormEl = document.getElementById(`${elementId}-edit-form`);
    const firstInput = editFormEl?.querySelector('input');


    if (displayEl && editFormEl && firstInput) {
      this.scroll_into_view(displayEl);
      displayEl.click()

      this.pendingFocus = null;
      return true;
    }

    return false;
  },

  scroll_into_view(element) {
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }
}
